import { render } from "./WpeTime.vue?vue&type=template&id=5d12a730"
import script from "./WpeTime.vue?vue&type=script&lang=js"
export * from "./WpeTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeTime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d12a730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d12a730', __exports__)) {
    api.reload('5d12a730', __exports__)
  }
  
  module.hot.accept("./WpeTime.vue?vue&type=template&id=5d12a730", () => {
    api.rerender('5d12a730', render)
  })

}


export default __exports__